import { call, put, takeLatest } from "redux-saga/effects";
import Swal from "sweetalert2";

import {
    FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST,
    fetchSavedCandidatesByDemandeSuccess,
    fetchSavedCandidatesByDemandeFail,

    SAVE_CANDIDATE_FOR_DEMANDE_REQUEST,
    saveCandidateForDemandeSuccess,
    saveCandidateForDemandeFail,

    UNSAVE_CANDIDATE_FOR_DEMANDE_REQUEST,
    unsaveCandidateForDemandeSuccess,
    unsaveCandidateForDemandeFail,

    setSavedCandidatesLoading,
} from "../actions/demandeCandidatSauvegardeActions";

import { API_BASE_URL, getRequest, postRequest, deleteRequest } from "../../../api";

const getUid = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

// ===== Fetch by demande =====
export function* fetchSavedCandidatesByDemandeSaga(action) {
    const { demandeId } = action.payload;
    const url = `${API_BASE_URL}/api/demande-candidat-sauvegardes/by-demande/${demandeId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setSavedCandidatesLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchSavedCandidatesByDemandeSuccess(resp.data));
    } catch (e) {
        yield put(fetchSavedCandidatesByDemandeFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setSavedCandidatesLoading(false));
    }
}

// ===== Save =====
export function* saveCandidateForDemandeSaga(action) {
    const url = `${API_BASE_URL}/api/demande-candidat-sauvegardes`;
    const uid = getUid();
    const token = getToken();

    yield put(setSavedCandidatesLoading(true));
    try {
        const resp = yield call(postRequest, {
            url,
            data: action.payload,
            uid,
            token,
        });

        yield put(saveCandidateForDemandeSuccess(resp.data));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidat sauvegardé",
            timer: 1400,
            showConfirmButton: false,
        });

        if (action.payload?.demandeId) {
            yield put({
                type: FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST,
                payload: { demandeId: action.payload.demandeId },
            });
        }
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur sauvegarde candidat";
        yield put(saveCandidateForDemandeFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setSavedCandidatesLoading(false));
    }
}

// ===== Unsave =====
export function* unsaveCandidateForDemandeSaga(action) {
    const { demandeId, candidatId } = action.payload;
    const url = `${API_BASE_URL}/api/demande-candidat-sauvegardes/by-demande-candidat?demandeId=${demandeId}&candidatId=${candidatId}`;
    const uid = getUid();
    const token = getToken();

    yield put(setSavedCandidatesLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });

        yield put(unsaveCandidateForDemandeSuccess({ demandeId, candidatId }));

        yield call([Swal, Swal.fire], {
            icon: "success",
            text: "Candidat retiré des sauvegardes",
            timer: 1400,
            showConfirmButton: false,
        });

        yield put({
            type: FETCH_SAVED_CANDIDATES_BY_DEMANDE_REQUEST,
            payload: { demandeId },
        });
    } catch (e) {
        const msg = e.response?.data?.message || "Erreur suppression sauvegarde";
        yield put(unsaveCandidateForDemandeFail(msg));
        yield call([Swal, Swal.fire], {
            icon: "error",
            text: msg,
            timer: 2200,
            showConfirmButton: false,
        });
    } finally {
        yield put(setSavedCandidatesLoading(false));
    }
}

